module.exports = __webpack_public_path__ + "img/744.3a8d904f.jpg";